import { deleteVendor } from "../../../../actions/CarrierAgreementMgmt/Vendor";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../components/toastNotification";

const useDeleteVendor = () => {
  const queryClient = useQueryClient();

  return useMutation((ids) => deleteVendor(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetVendor"]);
      toast.fire(
        "Success",
        "Vendor has been deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire("Failed", "Server Error: Cannot deactivate Vendor", "error");
    },
  });
};
export default useDeleteVendor;
